// Fetches and parses NZ surface observations from MetService coded-data endpoint (SYNOP format)

import { StationSeries, Observation } from './StationSeries.js';
import { wmoNZOscar } from './wmo-stations.js';
import { parseSynopLines as parseLines, extractSynopLines, parseWindMetService } from '../../../shared/synop-parser.js';

const BASE_URL = 'https://www.metservice.com/publicData/webdata/maps-radar/coded-data';

export class MetServiceSynopProvider {

  constructor(base = BASE_URL, fetchFn = fetch.bind(globalThis)) {
    this.base = base;
    this.fetchFn = fetchFn;
  }

  async fetch(start, end, bbox, now = Date.now()) {
    const lines = await this.fetchData(start, end, bbox);
    const stations = this.parseSynopLines(lines, now);
    return this.#filterStations(stations, start, end, bbox);
  }

  async fetchData(start, end, bbox) {
    const res = await this.fetchFn(this.base);
    const json = await res.json();
    const html = json.layout.secondary.slots.major.modules[0].content;
    return extractSynopLines(html);
  }

  //https://en.wikipedia.org/wiki/SYNOP
  parseSynopLines(lines, now = Date.now()) {
    return parseLines(lines, wmoNZOscar, 'metservice-synop', now, parseWindMetService)
      .map(s => {
        const series = new StationSeries(s.id, s.name, s.lat, s.lon, s.source);
        s.observations.forEach(o => series.addObservation(new Observation(o.t, o.dd, o.ff, o.tt, o.mslp)));
        return series;
      });
  }

  #filterStations(stations, start, end, bbox) {
    return stations
      .filter(s => s.lat != null && s.lon != null)
      .filter(s => s.lat >= bbox.minLat && s.lat <= bbox.maxLat && s.lon >= bbox.minLon && s.lon <= bbox.maxLon)
      .map(s => { s.observations = s.observations.filter(o => o.t >= start && o.t <= end); return s; })
      .filter(s => s.observations.length > 0);
  }
}
